const IGNORED_TEAM_UPDATE_KEYS = [
  'last_seen_at',
  'owner',
  'updated_at',
  'last_published_at',
  'first_published_at'
] as const

export function shouldAutosaveTeamChange(args: {
  diff: Record<string, unknown> | null | undefined
  isApplyingRemoteTeam: boolean
}): boolean {
  if (args.isApplyingRemoteTeam) {
    return false
  }

  if (!args.diff) {
    return true
  }

  const diffKeys = Object.keys(args.diff)
  if (diffKeys.length === 0) {
    return true
  }

  return !diffKeys.every((key) => IGNORED_TEAM_UPDATE_KEYS.includes(key as typeof IGNORED_TEAM_UPDATE_KEYS[number]))
}
